<template lang='pug'>
  transition(name='appear')
    .bf-dialog.component(v-if='show' :class='{ scrolled: scrolled }')
      bf-wrapper.container
        bf-flex.close.centered.actionable(@click.native='$emit("close")')
          img(src='/ui/close.svg' width='30')
        slot
</template>

<script>
  export default {
    name: 'bf-dialog.component',

    props: {
      show: Boolean,
      scrolled: Boolean
    }
  }
</script>

<style scoped lang='stylus'>
  .appear-leave
    //

  .appear-leave-to
    transition all 360ms
    transform scale(0)
    opacity .5

  .appear-enter
    opacity .5
    transform scale(0)

  .appear-enter-to
    opacity 1
    transform scale(1)
    transition all 360ms

  .bf-dialog
    position fixed
    height 100vh
    height calc( 100vh - 146px )
    width 100vw
    left 0
    top 49.5px
    padding-top 64px
    z-index 4
    background var(--bg-body)
    box-sizing border-box
    overflow-y auto
    @media(min-width: 1080px)
      // width calc( 100vw - var(--width-nav) )
      // left var(--width-nav)

  .close
    position absolute
    right 48px
    top -8px
    font-size 1.5em
    border-radius 50%
    border 1px dotted
    height 30px
    width 30px
    color rgba( 255 255 255 1 )
    z-index 1
    background rgba( 255 48 24 .75 )
    border 0
    box-shadow var(--shadow-box)
    @media(max-width: 800px)
      right 5.6vw

    @media(max-width: 480px)
      right 3.2vw
</style>
